import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const COOKIE_KEY = 'jugaly_cookies_accepted';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(COOKIE_KEY)) {
      setVisible(true);
    }
  }, []);

  function accept() {
    localStorage.setItem(COOKIE_KEY, '1');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Aviso de cookies"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[200] w-[min(36rem,calc(100vw-2rem))] rounded-2xl shadow-float px-5 py-4 flex items-center gap-4"
      style={{ background: 'var(--nav-bg)', backdropFilter: 'saturate(180%) blur(20px)', WebkitBackdropFilter: 'saturate(180%) blur(20px)' }}
    >
      <p className="flex-1 text-footnote text-ink-2">
        Usamos cookies técnicas necesarias para que el servicio funcione.{' '}
        <Link to="/privacidad" className="text-accent hover:underline">Más información</Link>
      </p>
      <button onClick={accept} className="btn-primary h-9 px-4 text-footnote shrink-0">Entendido</button>
    </div>
  );
}
